import { render, staticRenderFns } from "./BindSerial.vue?vue&type=template&id=0f560b3e"
import script from "./BindSerial.vue?vue&type=script&lang=js"
export * from "./BindSerial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports